/**
 * ActivationChecklist — Guided onboarding card shown when a tenant is unconfigured.
 * Disappears once any step is completed (any score > 0).
 */
import {
  Card,
  CardHeader,
  Title2,
  Body1,
  Body2,
  tokens,
} from '@fluentui/react-components';
import { RocketRegular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';

const steps = [
  { label: 'Connect your SDLC', path: '/developer-tools' },
  { label: 'Enable frameworks', path: '/frameworks' },
  { label: 'Configure enforcement', path: '/guardrails' },
  { label: 'Review findings', path: '/security' },
  { label: 'Verify evidence', path: '/evidence' },
  { label: 'Generate report', path: '/reports' },
];

export function ActivationChecklist() {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader
        image={<RocketRegular style={{ fontSize: '1.5rem', color: '#8852E0' }} />}
        header={<Title2>Get started with LeftShield</Title2>}
        description={<Body2 style={{ color: tokens.colorNeutralForeground3 }}>Complete these steps to activate your security posture</Body2>}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: tokens.spacingHorizontalM,
          padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalL}`,
        }}
      >
        {steps.map((step, i) => (
          <div
            key={step.path}
            onClick={() => navigate(step.path)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: tokens.spacingHorizontalS,
              padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
              borderRadius: tokens.borderRadiusMedium,
              backgroundColor: tokens.colorNeutralBackground2,
              cursor: 'pointer',
            }}
          >
            <Body2
              style={{
                color: '#8852E0',
                fontWeight: 600,
                minWidth: '20px',
              }}
            >
              {i + 1}.
            </Body2>
            <Body1>{step.label}</Body1>
          </div>
        ))}
      </div>
    </Card>
  );
}
